import { useEffect, useState } from 'react';

// Microsoft profile photo of a user as an object URL, or null when they have none (the server answers 204)
export function useProfilePhoto(userId) {
  const [photoUrl, setPhotoUrl] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;
    let active = true;
    let objectUrl = null;

    fetch(`/api/users/${userId}/photo`)
      .then((response) => (response.status === 200 ? response.blob() : null))
      .then((blob) => {
        if (!active || !blob?.size) return;
        objectUrl = URL.createObjectURL(blob);
        setPhotoUrl(objectUrl);
      })
      .catch(() => {});

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setPhotoUrl(null);
    };
  }, [userId]);

  return photoUrl;
}
